const FI = {
  ibanLength: 18,
};
export { FI };
